define('helper-entity-isQuizPage',["exports"], function (exports) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
        value: true
    });

    exports.default = function (entity) {
        return entity && entity.typeId === 19 ? true : false;
    };
});
